module.exports = __webpack_public_path__ + "img/icon-wine-lover.10a308cb.svg";